module.exports = __webpack_public_path__ + "/images/ico-social-pinterest.04a417c.svg";